// Import necessary components into the main NFT minting page

import Header from './componentsFolder/Header'
import Footer from './componentsFolder/Footer'
import Body from './componentsFolder/Body'
import About from './componentsFolder/About'
import Support from './componentsFolder/Support'
import { useState} from 'react'
import { BrowserRouter as Router, Route, Switch, Link } from 'react-router-dom'
import './MysticCharacters.css';
import React from 'react';

//This is the main functional component embodying all others
function MysticCharacters() {

    const [connectedAddress, setConnectedAddress] = useState('')
    async function getMintFunc (numOfMints, allowMint) {
        console.log(numOfMints, allowMint)
    }

    const [disconnectState, setDisconnectState] = useState('')
    async function disconnectFunc (discon) {
        setDisconnectState(discon)
    }

    const [checkDisconnected, setCheckDisconnected] = useState(false)
    async function checkMintableFuncMain (a) {
        setCheckDisconnected(a)
    }

    return (
        <Router>
            <div className= 'App'>
                <Switch>
                    <div className= 'background' style={{backgroundImage: 
                        'url("https://ipfs.io/ipfs/QmSn5t3cgNrnkfLrzLZhPZRNRBhTVAiUdx7tZ9Eko2P2ca/")'}}>
                        <Route path='/' exact render={(props)=> (
                            <>
                                <div >
                                    <Header onCheckMintable={checkMintableFuncMain} onAccess={disconnectFunc} onConnect={setConnectedAddress}/>
                                    <Body onAccessMint={disconnectState} onGet={getMintFunc} onReadAddress={connectedAddress} onAccessDisconnected={checkDisconnected}/>
                                    <Footer />
                                </div>
                            </>
                        )
                        } />
                        <Route path='/about' exact render={(props)=> (
                            <>
                                <div>
                                    <Header />
                                    <About />
                                    <Link to='/' className='about-class'>Back to HomePage</Link>
                                </div>
                            </>
                        )} />
                        <Route path='/support' exact render={(props)=> (
                            <>
                                <div>
                                    <Header />
                                    <Support />
                                    <Footer onLoad='support'/>
                                </div>
                            </>
                        )} />
                    </div>
                </Switch>
            </div>
        </Router>
    )
}

export default MysticCharacters